import React from "react";
import { Radio } from "lucide-react";
import { PageHeader } from "../lib/ui";
import ControlTower from "../components/ControlTower";
import { useT } from "../lib/i18n";

export default function ControlTowerPage() {
  const { t } = useT();
  return (
    <div className="animate-fade-up pb-24 lg:pb-2">
      <PageHeader icon={Radio} title={t("Operations Control Tower")}
        subtitle={t("Live status of today's operational cycle across all branches")} />
      <div className="mt-5"><ControlTower /></div>
    </div>
  );
}
